import {
	IMarineForecastData,
	IParamType,
} from "@/schemas/marine-forecast-schema";
import { IParameter } from "../types/parametres-type";

import i18n from "@/utils/i18n";

export const formatParameterName = (id: string): string => {
	switch (id) {
		case "Parameter_1":
			return i18n.t("parameter1");

		case "Parameter_2":
			return i18n.t("parameter2");

		default:
			return i18n.t("unknown");
	}
};

export const calcMaxValueChart = ({
	data,
	key,
}: {
	data: IMarineForecastData;
	key?: IParamType;
}): number | undefined => {
	if (!key) {
		return;
	}

	const values = data
		.map((item) => item[key])
		.filter((value): value is number => typeof value === "number");

	if (values.length === 0) {
		return;
	}

	return Math.ceil(Math.max(...values));
};
export const findParamsSelected = (
	data: IParameter[],
): IParameter | undefined => {
	if (data) {
		return data.find((item) => item.isSelected);
	}
};

export const filterMarineForecastByDate = (
	forecastData: IMarineForecastData,
) => {
	const now = new Date();

	const startOfToday = new Date(now);
	startOfToday.setHours(0, 0, 0, 0);

	const endOfToday = new Date(now);
	endOfToday.setHours(23, 59, 59, 999);

	const todayData = forecastData
		.filter((forecast) => {
			const d = new Date(forecast.timestep);
			return d >= startOfToday && d <= endOfToday;
		})
		.sort(
			(a, b) => new Date(a.timestep).getTime() - new Date(b.timestep).getTime(),
		);

	if (!todayData.length) return [];

	const lastToday = todayData[todayData.length - 1];

	const nextItem = forecastData.find((forecast) => {
		const d = new Date(forecast.timestep);
		return d > new Date(lastToday.timestep);
	});

	const fakeEnd = new Date(now);
	fakeEnd.setHours(23, 1, 0, 0);

	return [
		...todayData,
		nextItem
			? {
					...nextItem,
					timestep: fakeEnd.toISOString().slice(0, 16),
			  }
			: {
					...lastToday,
					timestep: fakeEnd.toISOString().slice(0, 16),
			  },
	];
};
